// @ts-nocheck
/* eslint-disable */
export const madarBrandingIconIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 149.378 22.849"><g fill="#fff" fill-rule="evenodd"><path d="M126.53 3.263h3.429a11.424 11.424 0 1 1 0 16.323H6.53v-3.263h124.894a8.161 8.161 0 1 0 0-9.8H0v-3.26z" data-name="Path 2"/><path d="M129.957 9.793h9.63v3.263H3.267V9.793z" data-name="Path 3"/></g></svg>`,
    name: 'madar-branding-icon' as const
};